<script setup lang="ts">
import Button from '../atoms/Button.vue'
import Countdown from '../atoms/Countdown.vue'
import SubTitle from '../atoms/SubTitle.vue'
import Title from '../atoms/Title.vue'
import Close from '../atoms/Icons/Close.vue'

interface Props {
  qrImg: string
  show: boolean
  tryCount?: number
  hasError?: boolean
}

const props = defineProps<Props>()
defineEmits(['closeModal', 'tryAgain'])
</script>

<template>
  <Teleport to="body">
    <div v-if="props.show" class="fixed inset-0 z-[999] bg-black/30 backdrop-blur-sm"></div>
    <div
      v-if="props.show"
      class="fixed left-1/2 top-1/2 z-[1000] flex w-full -translate-x-1/2 -translate-y-1/2 transform flex-col gap-5 overflow-hidden rounded-3xl bg-white shadow-2xl sm:max-w-[700px]"
    >
      <div class="relative flex w-full flex-col items-center justify-around border-b border-blue">
        <div class="relative flex w-full bg-blue-lighter py-4">
          <div class="absolute right-0 top-0">
            <button
              class="flex h-[60px] w-[60px] items-center justify-center"
              @click="$emit('closeModal')"
            >
              <Close />
            </button>
          </div>
          <div class="shrink-1 flex flex-1 items-center justify-center">
            <img v-if="props.qrImg" :src="props.qrImg" class="h-[210px] w-[210px]" />
          </div>
        </div>

        <div class="flex w-full flex-col px-4 pb-[60px] pt-4 sm:px-[138px] lg:pt-10">
          <SubTitle class="text-blue">QR</SubTitle>
          <Title custom-style="mb-2 leading-none lg:mb-2 lg:leading-none"> Skanna QR-kod</Title>

          <Countdown />

          <div class="mx-auto mt-8 w-full lg:mt-10 lg:w-[349px]">
            <Button
              title="Stäng"
              class="w-full"
              class-name-text="text-[16px]"
              @click="$emit('closeModal')"
            />
          </div>

          <div v-if="props.hasError" class="mx-auto mt-2 w-full lg:mt-2 lg:w-[349px]">
            <p
              v-if="props.tryCount && props.tryCount > 0 && props.tryCount < 10"
              class="text-gray text-center text-sm"
            >
              Du har {{ 10 - props.tryCount }} försök kvar
            </p>

            <Button
              title="Försök igen"
              class="mt-2 w-full"
              class-name-text="text-[16px]"
              :disabled="props.tryCount && props.tryCount >= 10"
              @click="$emit('tryAgain')"
            />
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>
